export default __webpack_public_path__ + "static/media/cn.14e877ff.svg";